import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

export function CockpitDrawer({ open, onOpenChange, title, description, children, testid }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-xl overflow-y-auto"
        style={{ background: "var(--hoip-card)", borderColor: "var(--hoip-border)", color: "var(--hoip-text-primary)" }}
        data-testid={testid || "cockpit-drawer"}
      >
        <SheetHeader>
          <SheetTitle className="text-sm">{title}</SheetTitle>
          {description ? (
            <SheetDescription className="text-[11px]" style={{ color: "var(--hoip-text-tertiary)" }}>
              {description}
            </SheetDescription>
          ) : null}
        </SheetHeader>
        <div className="mt-3">{children}</div>
      </SheetContent>
    </Sheet>
  );
}

export function RawTable({ columns, rows, testid }) {
  return (
    <div className="border overflow-x-auto" style={{ borderColor: "var(--hoip-border)" }}>
      <table className="w-full text-[10px] font-mono-data" data-testid={testid}>
        <thead>
          <tr style={{ color: "var(--hoip-text-tertiary)" }}>
            {columns.map((c) => (
              <th key={c.key} className={`px-2 py-1.5 ${c.align === "right" ? "text-right" : "text-left"}`}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id || i} className="border-t" style={{ borderColor: "var(--hoip-divider)" }}>
              {columns.map((c) => (
                <td key={c.key} className={`px-2 py-1.5 ${c.align === "right" ? "text-right" : "text-left"}`}>
                  {c.render ? c.render(row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
